import { pushToDataLayer } from './pushToDatalayer';
import { getParameters } from './formatter';
import { EVENTS } from './core/constants';
import { isDebugMode } from './core/utils';
import type { EventName, InitialConfig, PayloadFor } from './types';

let config: InitialConfig = { brand: '', currency: 'BRL' }
export function initTracker(c: InitialConfig) {
  config = c
}

async function trackWebEvent<E extends EventName>(event: E, context: PayloadFor<E>) {
  try {
    const parameters = await getParameters(context, event, config); // object data to be sent

    if (isDebugMode()) {
      console.log(`[DT v2] ${event}, context e parameters: `, {
        context,
        parameters,
      })
    }

    return await pushToDataLayer(
      event,
      Object.assign({}, parameters, { window: context.window })
    );
  } catch (err) {
    return console.error(`[DT] Error tracking event ${event}:`, err);
  }
}

export { trackWebEvent, EVENTS };

export default {
  trackWebEvent,
  EVENTS,
}
